export const env = {
  firebaseConfig: import.meta.env.VITE_FIREBASE_CONFIG || '{}',
  appId: import.meta.env.VITE_APP_ID || 'default-app-id',
  // Production URL for invite links (defaults to Cloudflare Pages URL)
  productionUrl: import.meta.env.VITE_PRODUCTION_URL || 'https://spirit-of-shabbat.pages.dev',
  // Firebase Cloud Messaging VAPID key for web push notifications
  vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY || '',
};

/**
 * Get the base URL for invite links.
 * Uses the configured production URL to ensure consistent invite links.
 */
export function getInviteLinkBaseUrl(): string {
  return env.productionUrl;
}
